import { type IFgasGwpItem } from "src/pages/Settings/YachtSetup/Fgas/Fgas.types";

export const FGAS_TAGS = {
  otherName: "fgas_OtherName",
  gwp: "fgas_GWP",
  eq: "fgas_EQ",
} as const;

export const FGAS_EQ_FEATURE = "fgasEqCalc";

export const getGwpList = (contentData: any): IFgasGwpItem[] => {
  const list = contentData?.latest?.gwp?.list ?? contentData?.gwp?.list;
  return Array.isArray(list) ? list : [];
};

export const calcFgasEq = (chargeWeight: unknown, gwp: unknown) => {
  const charge = parseFloat(String(chargeWeight ?? ""));
  const level = parseFloat(String(gwp ?? ""));
  if (Number.isNaN(charge) || Number.isNaN(level)) return "";

  return ((charge * level) / 1000).toFixed(2);
};

export const getRefrigerantOptions = (
  list: IFgasGwpItem[],
  currentValue?: string | null,
) => {
  const names = list
    .filter(item => item.active === 1)
    .map(item => item.refrigerant?.trim() ?? "")
    .filter(name => name !== "");

  const current = currentValue?.trim();
  if (current) names.push(current);

  return [...new Set(names)].map(name => ({ label: name, value: name }));
};
